const FETCH_PAYMENT_LINK_REQUEST = 'FETCH_PAYMENT_LINK_REQUEST';
const FETCH_PAYMENT_LINK_SUCCESS = 'FETCH_PAYMENT_LINK_SUCCESS';
const FETCH_PAYMENT_LINK_ERROR = 'FETCH_PAYMENT_LINK_ERROR';
const HIDE_PAYMENT_LINK_LOADER = 'HIDE_PAYMENT_LINK_LOADER';
const SHOW_PAYMENT_LINK_LOADER = 'SHOW_PAYMENT_LINK_LOADER';
const FETCH_TRANSACTION_PAYMENT_REQUEST = 'FETCH_TRANSACTION_PAYMENT_REQUEST';
const FETCH_TRANSACTION_PAYMENT_SUCCESS = 'FETCH_TRANSACTION_PAYMENT_SUCCESS';
const FETCH_TRANSACTION_PAYMENT_ERROR = 'FETCH_TRANSACTION_PAYMENT_ERROR';
const CREATE_PAY_LINK_REQUEST = 'CREATE_PAY_LINK_REQUEST';
const CREATE_PAY_LINK_SUCCESS = 'CREATE_PAY_LINK_SUCCESS';
const CREATE_PAY_LINK_ERROR = 'CREATE_PAY_LINK_ERROR';
const UPDATE_PAY_LINK_REQUEST = 'UPDATE_PAY_LINK_REQUEST';
const UPDATE_PAY_LINK_SUCCESS = 'UPDATE_PAY_LINK_SUCCESS';
const UPDATE_PAY_LINK_ERROR = 'UPDATE_PAY_LINK_ERROR';
const SHARE_PAY_LINK_REQUEST = 'SHARE_PAY_LINK_REQUEST';
const SHARE_PAY_LINK_SUCCESS = 'SHARE_PAY_LINK_SUCCESS';
const SHARE_PAY_LINK_ERROR = 'SHARE_PAY_LINK_ERROR';
const VIEW_PAY_LINK_REQUEST = 'VIEW_PAY_LINK_REQUEST';
const VIEW_PAY_LINK_SUCCESS = 'VIEW_PAY_LINK_SUCCESS';
const VIEW_PAY_LINK_ERROR = 'VIEW_PAY_LINK_ERROR';
const RE_SHARE_PAY_LINK_REQUEST = 'RE_SHARE_PAY_LINK_REQUEST';
const RE_SHARE_PAY_LINK_SUCCESS = 'RE_SHARE_PAY_LINK_SUCCESS';
const RE_SHARE_PAY_LINK_ERROR = 'RE_SHARE_PAY_LINK_ERROR';

const FETCH_MERCHANT_TEMPLATE_REQUEST = 'FETCH_MERCHANT_TEMPLATE_REQUEST';
const FETCH_MERCHANT_TEMPLATE_SUCCESS = 'FETCH_MERCHANT_TEMPLATE_SUCCESS';
const FETCH_MERCHANT_TEMPLATE_ERROR = 'FETCH_MERCHANT_TEMPLATE_ERROR';
const GENERATE_REPORT_REQUEST = 'GENERATE_REPORT_REQUEST2';
const GENERATE_REPORT_SUCCESS = 'GENERATE_REPORT_SUCCESS2';
const GENERATE_REPORT_ERROR = 'GENERATE_REPORT_ERROR2';


export {
    FETCH_PAYMENT_LINK_REQUEST,
    FETCH_PAYMENT_LINK_SUCCESS,
    FETCH_PAYMENT_LINK_ERROR,
    FETCH_TRANSACTION_PAYMENT_REQUEST,
    FETCH_TRANSACTION_PAYMENT_SUCCESS,
    FETCH_TRANSACTION_PAYMENT_ERROR,
    HIDE_PAYMENT_LINK_LOADER,
    SHOW_PAYMENT_LINK_LOADER,
    CREATE_PAY_LINK_REQUEST,
    CREATE_PAY_LINK_SUCCESS,
    CREATE_PAY_LINK_ERROR,
    UPDATE_PAY_LINK_REQUEST,
    UPDATE_PAY_LINK_SUCCESS,
    UPDATE_PAY_LINK_ERROR,
    SHARE_PAY_LINK_REQUEST,
    SHARE_PAY_LINK_SUCCESS,
    SHARE_PAY_LINK_ERROR,
    VIEW_PAY_LINK_REQUEST,
    VIEW_PAY_LINK_SUCCESS,
    VIEW_PAY_LINK_ERROR,
    RE_SHARE_PAY_LINK_REQUEST,
    RE_SHARE_PAY_LINK_SUCCESS,
    RE_SHARE_PAY_LINK_ERROR,
    FETCH_MERCHANT_TEMPLATE_REQUEST,
    FETCH_MERCHANT_TEMPLATE_SUCCESS,
    FETCH_MERCHANT_TEMPLATE_ERROR,
    GENERATE_REPORT_REQUEST,
    GENERATE_REPORT_SUCCESS,
    GENERATE_REPORT_ERROR,
};
